import Image from 'app/Components/Shared/Image/image';
import React from "react";
import BtnSubmit from "../../../../Shared/Buttons/BtnSubmit";

export const OptionPopUp = (props) => {
  return props.popUpObj ? (
    <div className="popUp-idf-family-members-sale">
      <div className="popUp-wrapper">
        {props.popUpObj?.icon && (
          <Image className="popUp-icon" src={props.popUpObj?.icon} />
        )}

        {props.popUpObj?.heading && (
          <div className="popUp-heading">{props.popUpObj?.heading}</div>
        )}

        {props.popUpObj?.secondaryHeading && (
          <div className="popUp-secondary-heading">
            {props.popUpObj?.secondaryHeading}
          </div>
        )}
      </div>
      
      {props.popUpObj?.buttonText &&<BtnSubmit
        text={props.popUpObj?.buttonText}
        onclick={() => props.onBtnClick()}
      />}

      {props.popUpObj?.footerText && (
        <div
          className="popUp-footer-text"
          onClick={() => props.popUpObj?.footerTextClicked()}
        >
          {props.popUpObj?.footerText}
        </div>
      )}
    </div>
  ) : null;
};
